var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDelete = function SvgDelete(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-584.000000, -325.000000)",
    fill: "#1DBADF"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(584.000000, 325.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.24,7.92 L12.24,12.96 L10.08,12.96 L10.08,7.92 L7.2,7.92 L7.2,12.96 L5.04,12.96 L5.04,7.92 L2.16,7.92 L2.16,14.4 C2.16,14.797645 2.48235498,15.12 2.88,15.12 L14.4,15.12 C14.797645,15.12 15.12,14.797645 15.12,14.4 L15.12,7.92 L12.24,7.92 L12.24,7.92 Z M3.19744231e-16,5.76 L17.28,5.76 L17.28,14.4 C17.28,15.9905801 15.9905801,17.28 14.4,17.28 L2.88,17.28 C1.28941992,17.28 9.01149331e-16,15.9905801 0,14.4 L3.19744231e-16,5.76 Z M5.76,2.16 L5.76,0 L11.52,0 L11.52,2.16 L17.28,2.16 L17.28,4.32 L0,4.32 L0,2.16 L5.76,2.16 Z"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDelete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete.9a5fbc83.svg";
export { ForwardRef as ReactComponent };